<script lang="ts">
  import { fly } from "svelte/transition";

  export let show: boolean;

  export let title: string;
  export let text: string = "";
  
  export let wins_1: number;
  export let wins_2: number | null = null;

  export let leave_game: Function;
  export let rematch: Function;

  export let show_history: boolean;
  export let show_actions: boolean;
  export let show_rematch: boolean;
</script>

{#if show}
  <div in:fly={{ y: 140, duration: 800 }} class="overlay">
    <h1>{title}</h1>
    {#if text.length > 0}
    <h2>{text}</h2>
    {/if}
    {#if show_history}
      <h2 class="history">
        <slot name="icon_2" />
        <div>
          {wins_2 || ""}
          <i class="fas fa-trophy gold" />
          {wins_1}
        </div>
        <slot name="icon_1" />
      </h2>

      {#if show_actions}
        <div class="actions">
          <h2
            on:click={() => {
              leave_game();
            }}
          >
            leave
          </h2>
          {#if show_rematch}
            <h2
              on:click={() => {
                rematch();
              }}
            >
              rematch
            </h2>
          {/if}
        </div>
      {/if}
    {/if}
  </div>
{/if}

<style>
  .overlay {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: absolute;
    z-index: 10;
    margin-left: -0.5rem;
    margin-top: 2.5rem;
    padding: 1rem;

    width: 334.61px;
    max-width: 334.61px;

    /* bottom: 50%; */
    background-color: var(--accent-color-trans);

    box-shadow: 0px 5px 10px 2px var(--accent-color-shadow);
    border-radius: 5px;
    user-select: none;
  }

  .overlay h1 {
    font-size: 1.5rem;
  }
  .gold {
    color: var(--gold);
  }

  .history {
    margin: 0;
    margin-bottom: 1rem;
    gap: 0.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: var(--text-color-secondary);
  }

  .actions {
    margin: 0;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: var(--text-color-secondary);
  }

  .actions h2 {
    margin: 0 1rem;
    font-size: 1.2rem;
    cursor: pointer;
  }

  .actions :hover {
    color: var(--text-color-hover);
  }

  .actions :active {
    color: var(--text-color-active);
  }
</style>
